// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs-2QUJr69","tabs-header":"tabs-header-h_Hxcej","tabs-body":"tabs-body-3FmEMBW"};